import { lazy } from 'react';
import type { HrSectionDef } from './pages/HrSectionPage';

// Pages and tabs load when first opened (NFR-04, docs §169).
const EmployeesTab = lazy(() => import('./components/EmployeesTab'));
const EstablishmentTab = lazy(() => import('./components/StructureTabs').then((m) => ({ default: m.EstablishmentTab })));
const GradesTab = lazy(() => import('./components/StructureTabs').then((m) => ({ default: m.GradesTab })));
const PersonnelActionsTab = lazy(() => import('./components/PersonnelActionsTab'));
const HolidaysTab = lazy(() => import('./components/LeaveTabs').then((m) => ({ default: m.HolidaysTab })));
const LeaveBalancesTab = lazy(() => import('./components/LeaveTabs').then((m) => ({ default: m.LeaveBalancesTab })));
const LeaveRequestsTab = lazy(() => import('./components/LeaveTabs').then((m) => ({ default: m.LeaveRequestsTab })));
const LeaveTypesTab = lazy(() => import('./components/LeaveTypesTab'));
const AttendanceTab = lazy(() => import('./components/TimeTabs').then((m) => ({ default: m.AttendanceTab })));
const OvertimeTab = lazy(() => import('./components/TimeTabs').then((m) => ({ default: m.OvertimeTab })));
const AbsencesTab = lazy(() => import('./components/TimeV2Tabs').then((m) => ({ default: m.AbsencesTab })));
const OvertimeRulesTab = lazy(() => import('./components/TimeV2Tabs').then((m) => ({ default: m.OvertimeRulesTab })));
const PreApprovalsTab = lazy(() => import('./components/TimeV2Tabs').then((m) => ({ default: m.PreApprovalsTab })));
const TimesheetsTab = lazy(() => import('./components/TimeV2Tabs').then((m) => ({ default: m.TimesheetsTab })));
const WorkCalendarsTab = lazy(() => import('./components/TimeV2Tabs').then((m) => ({ default: m.WorkCalendarsTab })));
const TeamCalendarTab = lazy(() => import('./components/LeaveV2Tabs').then((m) => ({ default: m.TeamCalendarTab })));
const YearEndTab = lazy(() => import('./components/LeaveV2Tabs').then((m) => ({ default: m.YearEndTab })));
const CustomFieldsTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.CustomFieldsTab })));
const DivisionsTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.DivisionsTab })));
const OnboardingTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.OnboardingTab })));
const OnboardingTemplatesTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.OnboardingTemplatesTab })));
const OrgChartTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.OrgChartTab })));
const PermitsTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.PermitsTab })));
const SalaryScaleTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.SalaryScaleTab })));
const UnionsTab = lazy(() => import('./components/PeopleV2Tabs').then((m) => ({ default: m.UnionsTab })));
const PayElementsTab = lazy(() => import('./components/PayrollSetupTabs').then((m) => ({ default: m.PayElementsTab })));
const PayGroupsTab = lazy(() => import('./components/PayrollSetupTabs').then((m) => ({ default: m.PayGroupsTab })));
const StatutoryTablesTab = lazy(() => import('./components/PayrollSetupTabs').then((m) => ({ default: m.StatutoryTablesTab })));
const ConfigChangesTab = lazy(() => import('./components/PayrollEngineTabs').then((m) => ({ default: m.ConfigChangesTab })));
const LookupTablesTab = lazy(() => import('./components/PayrollEngineTabs').then((m) => ({ default: m.LookupTablesTab })));
const RuleSetsTab = lazy(() => import('./components/PayrollEngineTabs').then((m) => ({ default: m.RuleSetsTab })));
const SchemesTab = lazy(() => import('./components/PayrollEngineTabs').then((m) => ({ default: m.SchemesTab })));
const ContractsSettingsTab = lazy(() => import('./components/ContractsTabs').then((m) => ({ default: m.ContractsSettingsTab })));
const DocumentTemplatesTab = lazy(() => import('./components/ContractsTabs').then((m) => ({ default: m.DocumentTemplatesTab })));
const RedundancyTab = lazy(() => import('./components/ContractsTabs').then((m) => ({ default: m.RedundancyTab })));
const PayrollRunsTab = lazy(() => import('./components/PayrollRunsTab'));
const PayrollImportsTab = lazy(() => import('./components/PayrollImportsTab'));
const ClaimsTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.ClaimsTab })));
const CourtOrdersTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.CourtOrdersTab })));
const DeferredTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.DeferredTab })));
const ExchangeRatesTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.ExchangeRatesTab })));
const GroupPreviewTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.GroupPreviewTab })));
const PayrollCalendarTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.PayrollCalendarTab })));
const RetroTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.RetroTab })));
const ThirdPartiesTab = lazy(() => import('./components/PayrollProcessingTabs').then((m) => ({ default: m.ThirdPartiesTab })));
const BankFormatsTab = lazy(() => import('./components/PayrollOutputTabs').then((m) => ({ default: m.BankFormatsTab })));
const LeaveLiabilityTab = lazy(() => import('./components/PayrollOutputTabs').then((m) => ({ default: m.LeaveLiabilityTab })));
const StatutoryReturnsTab = lazy(() => import('./components/PayrollOutputTabs').then((m) => ({ default: m.StatutoryReturnsTab })));
const LoansTab = lazy(() => import('./components/LoansAndExit').then((m) => ({ default: m.LoansTab })));
const LoanAgeingTab = lazy(() => import('./components/LoansV2Tabs').then((m) => ({ default: m.LoanAgeingTab })));
const LoanTypesTab = lazy(() => import('./components/LoansV2Tabs').then((m) => ({ default: m.LoanTypesTab })));
const AnnualPayeTab = lazy(() => import('./components/PaymentsTabs').then((m) => ({ default: m.AnnualPayeTab })));
const PayslipTemplatesTab = lazy(() => import('./components/PaymentsTabs').then((m) => ({ default: m.PayslipTemplatesTab })));
const RemittancesTab = lazy(() => import('./components/PaymentsTabs').then((m) => ({ default: m.RemittancesTab })));
const ReturnTemplatesTab = lazy(() => import('./components/PaymentsTabs').then((m) => ({ default: m.ReturnTemplatesTab })));
const ControlAccountsTab = lazy(() => import('./components/AccountingTabs').then((m) => ({ default: m.ControlAccountsTab })));
const PayrollLedgerTab = lazy(() => import('./components/AccountingTabs').then((m) => ({ default: m.PayrollLedgerTab })));
const PostingRulesTab = lazy(() => import('./components/AccountingTabs').then((m) => ({ default: m.PostingRulesTab })));
const ApplicantsTab = lazy(() => import('./components/RecruitmentTabs').then((m) => ({ default: m.ApplicantsTab })));
const RequisitionsTab = lazy(() => import('./components/RecruitmentTabs').then((m) => ({ default: m.RequisitionsTab })));
const VacanciesTab = lazy(() => import('./components/RecruitmentTabs').then((m) => ({ default: m.VacanciesTab })));
const CasesTab = lazy(() => import('./components/DevelopmentTabs').then((m) => ({ default: m.CasesTab })));
const CompetenciesTab = lazy(() => import('./components/DevelopmentTabs').then((m) => ({ default: m.CompetenciesTab })));
const CyclesTab = lazy(() => import('./components/DevelopmentTabs').then((m) => ({ default: m.CyclesTab })));
const GrievancesTab = lazy(() => import('./components/DevelopmentTabs').then((m) => ({ default: m.GrievancesTab })));
const TrainingTab = lazy(() => import('./components/DevelopmentTabs').then((m) => ({ default: m.TrainingTab })));
const AppraisalFormsTab = lazy(() => import('./components/PerformanceTabs').then((m) => ({ default: m.AppraisalFormsTab })));
const CalibrationTab = lazy(() => import('./components/PerformanceTabs').then((m) => ({ default: m.CalibrationTab })));
const ImprovementPlansTab = lazy(() => import('./components/PerformanceTabs').then((m) => ({ default: m.ImprovementPlansTab })));
const MeritTab = lazy(() => import('./components/PerformanceTabs').then((m) => ({ default: m.MeritTab })));
const ObjectivesTab = lazy(() => import('./components/PerformanceTabs').then((m) => ({ default: m.ObjectivesTab })));
const TrainingPlanningTab = lazy(() => import('./components/PerformanceTabs').then((m) => ({ default: m.TrainingPlanningTab })));
const CodeTab = lazy(() => import('./components/ComplianceTabs').then((m) => ({ default: m.CodeTab })));
const PoliciesTab = lazy(() => import('./components/ComplianceTabs').then((m) => ({ default: m.PoliciesTab })));
const PrivacyTab = lazy(() => import('./components/ComplianceTabs').then((m) => ({ default: m.PrivacyTab })));
const RetentionTab = lazy(() => import('./components/ComplianceTabs').then((m) => ({ default: m.RetentionTab })));
const SafetyTab = lazy(() => import('./components/ComplianceTabs').then((m) => ({ default: m.SafetyTab })));
const WelfareTab = lazy(() => import('./components/ComplianceTabs').then((m) => ({ default: m.WelfareTab })));
const EwaTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.EwaTab })));
const ExperienceSettingsTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.ExperienceSettingsTab })));
const HelpdeskTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.HelpdeskTab })));
const KudosTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.KudosTab })));
const LifeEventsTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.LifeEventsTab })));
const PreStartTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.PreStartTab })));
const SurveysTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.SurveysTab })));
const WellnessTab = lazy(() => import('./components/ExperienceTabs').then((m) => ({ default: m.WellnessTab })));
const HrReportsTab = lazy(() => import('./components/HrReportsTab'));
const HrDashboardTab = lazy(() => import('./components/HrReportBuilderTab').then((m) => ({ default: m.HrDashboardTab })));
const HrReportBuilderTab = lazy(() => import('./components/HrReportBuilderTab').then((m) => ({ default: m.HrReportBuilderTab })));
const BargainingTab = lazy(() => import('./components/WorkforceTabs').then((m) => ({ default: m.BargainingTab })));
const CertificatesTab = lazy(() => import('./components/WorkforceTabs').then((m) => ({ default: m.CertificatesTab })));
const ComplianceRadarTab = lazy(() => import('./components/WorkforceTabs').then((m) => ({ default: m.ComplianceRadarTab })));
const EventRulesTab = lazy(() => import('./components/WorkforceTabs').then((m) => ({ default: m.EventRulesTab })));
const IntelligenceTab = lazy(() => import('./components/WorkforceTabs').then((m) => ({ default: m.IntelligenceTab })));
const SuccessionTab = lazy(() => import('./components/WorkforceTabs').then((m) => ({ default: m.SuccessionTab })));
const OpeningBalancesTab = lazy(() => import('./components/IntegrationTabs').then((m) => ({ default: m.OpeningBalancesTab })));
const IntercompanyTab = lazy(() => import('./components/IntegrationTabs').then((m) => ({ default: m.IntercompanyTab })));
const WorkforcePlansTab = lazy(() => import('./components/WorkforceTabs').then((m) => ({ default: m.WorkforcePlansTab })));
const HrSettingsAccountsTab = lazy(() => import('./components/HrSettingsTab').then((m) => ({ default: m.HrSettingsAccountsTab })));
const HrSettingsCareersTab = lazy(() => import('./components/HrSettingsTab').then((m) => ({ default: m.HrSettingsCareersTab })));
const HrSettingsGeneralTab = lazy(() => import('./components/HrSettingsTab').then((m) => ({ default: m.HrSettingsGeneralTab })));
const HrSettingsNumberingTab = lazy(() => import('./components/HrSettingsTab').then((m) => ({ default: m.HrSettingsNumberingTab })));
const HrSettingsPayrollTab = lazy(() => import('./components/HrSettingsTab').then((m) => ({ default: m.HrSettingsPayrollTab })));

/**
 * The HR module's sections, one per menu item, each with its leaves. The URL's last segment names
 * the leaf, so every tab is a real address that can be shared, and the rights the leaf needs are
 * read once by the page and handed to the tab.
 *
 * The const is called `sections`, like the accounting module's: `scripts/check-routes.mjs` reads
 * these files to prove every tab has a route behind it.
 */
export const sections = {
  employees: {
    area: 'People', title: 'Employees', basePath: '/hr/people/employees',
    description: 'The register: everyone the organisation employs or engages, with or without a login. Open a record for its details, documents, history and leave.',
    views: [
      { key: 'register', label: 'Register' },
      { key: 'onboarding', label: 'Onboarding' },
      { key: 'permits', label: 'Permits' },
      { key: 'org-chart', label: 'Org chart' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'onboarding': return <OnboardingTab ctx={ctx} />;
        case 'permits': return <PermitsTab />;
        case 'org-chart': return <OrgChartTab />;
        default: return <EmployeesTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'register' | 'onboarding' | 'permits' | 'org-chart'>,

  structure: {
    area: 'People', title: 'Structure', basePath: '/hr/people/structure',
    description: 'Positions as an establishment — how many are approved, budgeted, in post and vacant — the pay grades and the salary scale they sit in, divisions and unions.',
    views: [
      { key: 'establishment', label: 'Positions & headcount' },
      { key: 'grades', label: 'Grades' },
      { key: 'salary-scale', label: 'Salary scale' },
      { key: 'divisions', label: 'Divisions' },
      { key: 'unions', label: 'Unions' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'grades': return <GradesTab ctx={ctx} />;
        case 'salary-scale': return <SalaryScaleTab ctx={ctx} />;
        case 'divisions': return <DivisionsTab ctx={ctx} />;
        case 'unions': return <UnionsTab ctx={ctx} />;
        default: return <EstablishmentTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'establishment' | 'grades' | 'salary-scale' | 'divisions' | 'unions'>,

  actions: {
    area: 'People', title: 'Personnel Actions', basePath: '/hr/people/actions',
    description: 'Every change to pay, grade, position, department or cost centre: dated, approved, and applied on the day it takes effect.',
    views: [
      { key: 'drafts', label: 'Drafts' },
      { key: 'pending', label: 'Awaiting approval' },
      { key: 'scheduled', label: 'Approved, not yet in effect' },
      { key: 'history', label: 'History' },
      { key: 'redundancy', label: 'Redundancy cases' },
    ],
    render: (view, ctx) => (view === 'redundancy' ? <RedundancyTab ctx={ctx} /> : <PersonnelActionsTab ctx={ctx} view={view} />),
  } satisfies HrSectionDef<'drafts' | 'pending' | 'scheduled' | 'history' | 'redundancy'>,

  leaveRequests: {
    area: 'Leave', title: 'Leave Requests', basePath: '/hr/leave/requests',
    description: 'Asking for leave with the balance shown first, and the leave of your team and the organisation.',
    views: [
      { key: 'mine', label: 'Mine' },
      { key: 'team', label: 'My team' },
      { key: 'all', label: 'Everyone' },
      { key: 'calendar', label: 'Who is away' },
    ],
    render: (view, ctx) => (view === 'calendar' ? <TeamCalendarTab ctx={ctx} scope={ctx.canLeave ? 'all' : 'team'} /> : <LeaveRequestsTab ctx={ctx} scope={view} />),
  } satisfies HrSectionDef<'mine' | 'team' | 'all' | 'calendar'>,

  leaveBalances: {
    area: 'Leave', title: 'Leave Balances', basePath: '/hr/leave/balances',
    description: 'What each person has earned, taken, carried and lost, every figure explainable movement by movement; and the year end seen before it happens, with encashment.',
    views: [
      { key: 'balances', label: 'Balances' },
      { key: 'year-end', label: 'Year end & encashment' },
    ],
    render: (view, ctx) => (view === 'year-end' ? <YearEndTab ctx={ctx} /> : <LeaveBalancesTab ctx={ctx} />),
  } satisfies HrSectionDef<'balances' | 'year-end'>,

  holidays: {
    area: 'Leave', title: 'Public Holidays', basePath: '/hr/leave/holidays',
    description: 'The days nobody works and no leave is deducted for.',
    views: [{ key: 'calendar', label: 'Calendar' }],
    render: (_view, ctx) => <HolidaysTab ctx={ctx} />,
  } satisfies HrSectionDef<'calendar'>,

  attendance: {
    area: 'Time', title: 'Attendance', basePath: '/hr/time/attendance',
    description: 'Days at work, from HR’s own entries and from time-clock exports read once. An entry HR makes is never overwritten by an import.',
    views: [
      { key: 'all', label: 'Everyone' },
      { key: 'team', label: 'My team' },
      { key: 'mine', label: 'Mine' },
      { key: 'timesheets', label: 'Time sheets' },
      { key: 'absences', label: 'Absences' },
      { key: 'calendars', label: 'Calendars & shifts' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'timesheets': return <TimesheetsTab ctx={ctx} scope={ctx.canAttendance ? 'all' : 'mine'} />;
        case 'absences': return <AbsencesTab ctx={ctx} scope={ctx.canAttendance ? 'all' : 'team'} />;
        case 'calendars': return <WorkCalendarsTab ctx={ctx} />;
        default: return <AttendanceTab ctx={ctx} scope={view} />;
      }
    },
  } satisfies HrSectionDef<'all' | 'team' | 'mine' | 'timesheets' | 'absences' | 'calendars'>,

  overtime: {
    area: 'Time', title: 'Overtime', basePath: '/hr/time/overtime',
    description: 'Overtime claimed, priced by the day it was worked under the person’s rule and approved by the claimant’s own line manager; pre-approval where a rule demands it. Only approved overtime reaches payroll.',
    views: [
      { key: 'mine', label: 'Mine' },
      { key: 'team', label: 'My team' },
      { key: 'all', label: 'Everyone' },
      { key: 'pre-approvals', label: 'Pre-approvals' },
      { key: 'rules', label: 'Rules' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'pre-approvals': return <PreApprovalsTab ctx={ctx} scope={ctx.canAttendance ? 'all' : 'mine'} />;
        case 'rules': return <OvertimeRulesTab ctx={ctx} />;
        default: return <OvertimeTab ctx={ctx} scope={view} />;
      }
    },
  } satisfies HrSectionDef<'mine' | 'team' | 'all' | 'pre-approvals' | 'rules'>,

  payrollRuns: {
    area: 'Payroll', title: 'Payroll Runs', basePath: '/hr/payroll/runs',
    description: 'The month’s pay: opened, calculated, checked, approved by HR and then finance, and closed. A closed run is frozen; a correction is an off-cycle run.',
    views: [
      { key: 'current', label: 'In progress' },
      { key: 'closed', label: 'Closed' },
      { key: 'all', label: 'All' },
      { key: 'imported', label: 'Imported from another system' },
    ],
    render: (view, ctx) => (view === 'imported' ? <PayrollImportsTab ctx={ctx} /> : <PayrollRunsTab ctx={ctx} view={view} />),
  } satisfies HrSectionDef<'current' | 'closed' | 'all' | 'imported'>,

  payrollProcessing: {
    area: 'Payroll', title: 'Payroll Processing', basePath: '/hr/payroll/processing',
    description: 'What runs draw on besides the record: the pay calendar and its due dates, a trial run of a whole group, claims, arrears from back-dated changes, deductions the cap held back, court orders, the third parties deductions are paid to, and exchange rates.',
    views: [
      { key: 'calendar', label: 'Pay calendar' },
      { key: 'trial', label: 'Trial run' },
      { key: 'claims', label: 'Claims' },
      { key: 'retro', label: 'Arrears' },
      { key: 'deferred', label: 'Held-back deductions' },
      { key: 'court-orders', label: 'Court orders' },
      { key: 'third-parties', label: 'Third parties' },
      { key: 'fx', label: 'Exchange rates' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'trial': return <GroupPreviewTab />;
        case 'claims': return <ClaimsTab ctx={ctx} />;
        case 'retro': return <RetroTab ctx={ctx} />;
        case 'deferred': return <DeferredTab ctx={ctx} />;
        case 'court-orders': return <CourtOrdersTab ctx={ctx} />;
        case 'third-parties': return <ThirdPartiesTab ctx={ctx} />;
        case 'fx': return <ExchangeRatesTab ctx={ctx} />;
        default: return <PayrollCalendarTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'calendar' | 'trial' | 'claims' | 'retro' | 'deferred' | 'court-orders' | 'third-parties' | 'fx'>,

  payrollLoans: {
    area: 'Payroll', title: 'Loans & Advances', basePath: '/hr/payroll/loans',
    description: 'Staff loans, salary advances and scheme loans: typed, priced and checked against what the person can carry, approved, paid out, and recovered by payroll on their schedule until nothing is owed.',
    views: [
      { key: 'active', label: 'Being recovered' },
      { key: 'pending', label: 'Awaiting approval or payout' },
      { key: 'closed', label: 'Closed' },
      { key: 'ageing', label: 'Ageing' },
      { key: 'types', label: 'Loan types' },
    ],
    render: (view, ctx) => (view === 'ageing' ? <LoanAgeingTab /> : view === 'types' ? <LoanTypesTab ctx={ctx} /> : <LoansTab ctx={ctx} view={view} />),
  } satisfies HrSectionDef<'active' | 'pending' | 'closed' | 'ageing' | 'types'>,

  payrollOutput: {
    area: 'Payroll', title: 'Returns & Liability', basePath: '/hr/payroll/output',
    description: 'What closed payrolls owe outside the organisation: every scheme\u2019s return from its template, the remittances due and paid, the year\u2019s PAYE and tax certificates, the value of the paid leave staff are owed, how payslips look, and the control accounts against the ledger.',
    views: [
      { key: 'returns', label: 'Statutory returns' },
      { key: 'remittances', label: 'Remittances' },
      { key: 'ledger', label: 'Ledger & month end' },
      { key: 'annual', label: 'Year end & certificates' },
      { key: 'leave-liability', label: 'Leave liability' },
      { key: 'templates', label: 'Return templates' },
      { key: 'payslips', label: 'Payslip layout' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'remittances': return <RemittancesTab ctx={ctx} />;
        case 'ledger': return <PayrollLedgerTab ctx={ctx} />;
        case 'annual': return <AnnualPayeTab ctx={ctx} />;
        case 'leave-liability': return <LeaveLiabilityTab ctx={ctx} />;
        case 'templates': return <ReturnTemplatesTab ctx={ctx} />;
        case 'payslips': return <PayslipTemplatesTab ctx={ctx} />;
        default: return <StatutoryReturnsTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'returns' | 'remittances' | 'ledger' | 'annual' | 'leave-liability' | 'templates' | 'payslips'>,

  payrollSetup: {
    area: 'Payroll', title: 'Payroll Set-up', basePath: '/hr/payroll/setup',
    description: 'What payroll is worked out from: the statutory tables, approved before use; the pay elements and the accounts they post to; the pay groups; and the bank file layouts.',
    views: [
      { key: 'statutory', label: 'Statutory tables' },
      { key: 'schemes', label: 'Schemes' },
      { key: 'elements', label: 'Pay elements' },
      { key: 'lookups', label: 'Lookups & floors' },
      { key: 'rule-sets', label: 'Rule sets' },
      { key: 'changes', label: 'Change log' },
      { key: 'groups', label: 'Pay groups' },
      { key: 'bank-formats', label: 'Bank file formats' },
      { key: 'posting-rules', label: 'Posting rules' },
      { key: 'controls', label: 'Control accounts' },
      { key: 'opening', label: 'Opening balances' },
      { key: 'intercompany', label: 'Group companies' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'schemes': return <SchemesTab ctx={ctx} />;
        case 'elements': return <PayElementsTab ctx={ctx} />;
        case 'lookups': return <LookupTablesTab ctx={ctx} />;
        case 'rule-sets': return <RuleSetsTab ctx={ctx} />;
        case 'changes': return <ConfigChangesTab />;
        case 'groups': return <PayGroupsTab ctx={ctx} />;
        case 'bank-formats': return <BankFormatsTab ctx={ctx} />;
        case 'posting-rules': return <PostingRulesTab ctx={ctx} />;
        case 'controls': return <ControlAccountsTab ctx={ctx} />;
        case 'opening': return <OpeningBalancesTab ctx={ctx} />;
        case 'intercompany': return <IntercompanyTab ctx={ctx} />;
        default: return <StatutoryTablesTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'statutory' | 'schemes' | 'elements' | 'lookups' | 'rule-sets' | 'changes' | 'groups' | 'bank-formats' | 'posting-rules' | 'controls' | 'opening' | 'intercompany'>,

  recruitment: {
    area: 'Recruitment', title: 'Recruitment', basePath: '/hr/recruitment',
    description: 'From a request to fill a post, approved by HR and finance, to an advertisement, the applicants along the pipeline, interviews, and an offer that becomes an employee.',
    views: [
      { key: 'requisitions', label: 'Requisitions' },
      { key: 'vacancies', label: 'Vacancies' },
      { key: 'applicants', label: 'Applicants' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'vacancies': return <VacanciesTab ctx={ctx} />;
        case 'applicants': return <ApplicantsTab ctx={ctx} />;
        default: return <RequisitionsTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'requisitions' | 'vacancies' | 'applicants'>,

  development: {
    area: 'Development', title: 'Performance & Training', basePath: '/hr/development',
    description: 'Appraisal cycles — agreed, self-rated, rated by the line manager, calibrated by HR and signed — on forms for each kind of role; departmental objectives cascaded and measured; merit and bonus; improvement plans; and the training people need, are planned for and have done.',
    views: [
      { key: 'appraisals', label: 'Appraisals' },
      { key: 'objectives', label: 'Objectives' },
      { key: 'calibration', label: 'Calibration' },
      { key: 'merit', label: 'Merit & bonus' },
      { key: 'improvement', label: 'Improvement plans' },
      { key: 'training', label: 'Training' },
      { key: 'planning', label: 'Training plan' },
      { key: 'forms', label: 'Appraisal forms' },
      { key: 'competencies', label: 'Competencies' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'objectives': return <ObjectivesTab ctx={ctx} />;
        case 'calibration': return <CalibrationTab />;
        case 'merit': return <MeritTab ctx={ctx} />;
        case 'improvement': return <ImprovementPlansTab ctx={ctx} />;
        case 'training': return <TrainingTab ctx={ctx} />;
        case 'planning': return <TrainingPlanningTab ctx={ctx} />;
        case 'forms': return <AppraisalFormsTab ctx={ctx} />;
        case 'competencies': return <CompetenciesTab ctx={ctx} />;
        default: return <CyclesTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'appraisals' | 'objectives' | 'calibration' | 'merit' | 'improvement' | 'training' | 'planning' | 'forms' | 'competencies'>,

  relations: {
    area: 'Relations', title: 'Employee Relations', basePath: '/hr/relations',
    description: 'Disciplinary cases and grievances. Sensitive: seen only by those with the right to see sensitive records.',
    views: [
      { key: 'cases', label: 'Disciplinary cases' },
      { key: 'grievances', label: 'Grievances' },
    ],
    render: (view, ctx) => (view === 'grievances' ? <GrievancesTab ctx={ctx} /> : <CasesTab ctx={ctx} />),
  } satisfies HrSectionDef<'cases' | 'grievances'>,

  compliance: {
    area: 'Relations', title: 'Compliance', basePath: '/hr/compliance',
    description: 'The disciplinary code, the policies people acknowledge, injuries and medical surveillance, welfare and labour cases, privacy — consent, requests and breaches — and how long records are kept.',
    views: [
      { key: 'code', label: 'Disciplinary code' },
      { key: 'policies', label: 'Policies' },
      { key: 'safety', label: 'Health & safety' },
      { key: 'welfare', label: 'Welfare & labour cases' },
      { key: 'privacy', label: 'Privacy' },
      { key: 'retention', label: 'Retention' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'policies': return <PoliciesTab ctx={ctx} />;
        case 'safety': return <SafetyTab ctx={ctx} />;
        case 'welfare': return <WelfareTab ctx={ctx} />;
        case 'privacy': return <PrivacyTab ctx={ctx} />;
        case 'retention': return <RetentionTab ctx={ctx} />;
        default: return <CodeTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'code' | 'policies' | 'safety' | 'welfare' | 'privacy' | 'retention'>,

  experience: {
    area: 'Relations', title: 'Employee experience', basePath: '/hr/experience',
    description: 'HR’s side of Annova Me: earned pay drawn early, the helpdesk, life events, pre-start links, surveys, wellness, kudos, and the portal’s settings, kiosks and verifications.',
    views: [
      { key: 'ewa', label: 'Earned pay' },
      { key: 'helpdesk', label: 'Helpdesk' },
      { key: 'life-events', label: 'Life events' },
      { key: 'onboarding', label: 'Pre-start links' },
      { key: 'surveys', label: 'Surveys' },
      { key: 'wellness', label: 'Wellness' },
      { key: 'kudos', label: 'Kudos' },
      { key: 'settings', label: 'Settings' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'helpdesk': return <HelpdeskTab ctx={ctx} />;
        case 'life-events': return <LifeEventsTab ctx={ctx} />;
        case 'onboarding': return <PreStartTab ctx={ctx} />;
        case 'surveys': return <SurveysTab ctx={ctx} />;
        case 'wellness': return <WellnessTab ctx={ctx} />;
        case 'kudos': return <KudosTab ctx={ctx} />;
        case 'settings': return <ExperienceSettingsTab ctx={ctx} />;
        default: return <EwaTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'ewa' | 'helpdesk' | 'life-events' | 'onboarding' | 'surveys' | 'wellness' | 'kudos' | 'settings'>,

  workforce: {
    area: 'Reports', title: 'Workforce & Insight', basePath: '/hr/workforce',
    description: 'Ask a report in a sentence, the signs of attrition, pay equity and pay offers costed on the last payroll; what the employer must keep current; rules that act when something happens; workforce plans, succession and compliance certificates.',
    views: [
      { key: 'insight', label: 'Insight' },
      { key: 'bargaining', label: 'Pay offers' },
      { key: 'radar', label: 'Compliance radar' },
      { key: 'rules', label: 'Event rules' },
      { key: 'plans', label: 'Workforce plan' },
      { key: 'succession', label: 'Succession' },
      { key: 'certificates', label: 'Certificates' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'bargaining': return ctx.canViewPay ? <BargainingTab /> : <IntelligenceTab ctx={ctx} />;
        case 'radar': return <ComplianceRadarTab />;
        case 'rules': return <EventRulesTab ctx={ctx} />;
        case 'plans': return <WorkforcePlansTab ctx={ctx} />;
        case 'succession': return <SuccessionTab ctx={ctx} />;
        case 'certificates': return <CertificatesTab ctx={ctx} />;
        default: return <IntelligenceTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'insight' | 'bargaining' | 'radar' | 'rules' | 'plans' | 'succession' | 'certificates'>,

  reports: {
    area: 'Reports', title: 'HR Reports', basePath: '/hr/reports',
    description: 'Headcount, movement, leave, payroll cost, overtime, remittances, contracts, recruitment, diversity and training — for any period, and as sections for reports and board packs.',
    views: [{ key: 'all', label: 'Reports' }, { key: 'builder', label: 'Report builder' }, { key: 'dashboard', label: 'Dashboard' }],
    render: (view, ctx) => (view === 'builder' ? <HrReportBuilderTab ctx={ctx} /> : view === 'dashboard' ? <HrDashboardTab /> : <HrReportsTab ctx={ctx} />),
  } satisfies HrSectionDef<'all' | 'builder' | 'dashboard'>,

  settings: {
    area: 'HR', title: 'HR Settings', basePath: '/hr/settings',
    description: 'The working calendar, the leave types, the warning horizons, the payroll controls, the accounts a payroll journal posts to, and the public careers page.',
    views: [
      { key: 'general', label: 'Calendar & warnings' },
      { key: 'leave-types', label: 'Leave types' },
      { key: 'payroll', label: 'Payroll controls' },
      { key: 'accounts', label: 'Accounts' },
      { key: 'contracts', label: 'Contracts & separation' },
      { key: 'templates', label: 'Document templates' },
      { key: 'careers', label: 'Careers page' },
      { key: 'numbering', label: 'Numbering' },
      { key: 'custom-fields', label: 'Custom fields' },
      { key: 'onboarding', label: 'Onboarding' },
    ],
    render: (view, ctx) => {
      switch (view) {
        case 'leave-types': return <LeaveTypesTab ctx={ctx} />;
        case 'payroll': return <HrSettingsPayrollTab ctx={ctx} />;
        case 'accounts': return <HrSettingsAccountsTab ctx={ctx} />;
        case 'contracts': return <ContractsSettingsTab ctx={ctx} />;
        case 'templates': return <DocumentTemplatesTab ctx={ctx} />;
        case 'careers': return <HrSettingsCareersTab ctx={ctx} />;
        case 'numbering': return <HrSettingsNumberingTab />;
        case 'custom-fields': return <CustomFieldsTab ctx={ctx} />;
        case 'onboarding': return <OnboardingTemplatesTab ctx={ctx} />;
        default: return <HrSettingsGeneralTab ctx={ctx} />;
      }
    },
  } satisfies HrSectionDef<'general' | 'leave-types' | 'payroll' | 'accounts' | 'contracts' | 'templates' | 'careers' | 'numbering' | 'custom-fields' | 'onboarding'>,
};
